import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SplitPaymentShouldBeCheckedWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.split-payment.split-payment-should-be-checked');
    }
}
